import { styled } from '@pata-app/themes';

export const FollowUsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0 ${({ theme }) => theme.core.sizing[2]}px;

  height: 400px;

  background: ${({ theme }) => theme.core.colors.primary.green.medium};
  color: ${({ theme }) => theme.core.colors.greyscale.white};

  p,
  h2 {
    text-align: center;
    margin: 0;
  }

  h2 {
    font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;
    font-weight: ${({ theme }) => theme.core.fontWeight.semiBold};
  }

  p {
    margin-top: ${({ theme }) => theme.core.sizing[1]}px;
    margin-bottom: ${({ theme }) => theme.core.sizing[4]}px;

    max-width: 550px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    margin-top: -75px;
  }
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  margin-top: ${({ theme }) => theme.core.sizing[4]}px;
`;

export const LinkContainer = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.core.colors.greyscale.white};
  }
`;
